import React, { useEffect, useRef, useState } from "react";
import CustomNav from "../components/CustomNav";
import { Container, Row, Col, Card } from "react-bootstrap";
import video from "../images/pcb.MP4";
import news1 from "../images/news1.jpeg";
import NewsCards from "../components/NewsCards";
import { FaMicrochip, FaBolt, FaLayerGroup, FaLightbulb, FaCogs, FaClipboardList, FaThList } from "react-icons/fa";
import LEDPCB from "../components/LEDPCB";
import Footer from "../components/Footer";
import pcb from "../images/logo.webp"
import NewNav from "../components/NewNav";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);



const features = [
  {
    icon: <FaLightbulb className="icon" />, 
    title: "Purpose",
    description: (
      <>
        LED PCBs are used to mount LEDs and to distribute electrical power across them.<br />
        They ensure that the LEDs work correctly by providing an organized layout for the components.
      </>
    ),
  },
  {
    icon: <FaCogs className="icon" />, 
    title: "Thermal Management",
    description: (
      <>
        LEDs generate heat, and excessive heat can reduce their lifespan.<br />
        LED PCBs often use thermal management materials (like aluminum or copper) to dissipate heat efficiently and maintain optimal operating temperatures.
      </>
    ),
  },
  {
    icon: <FaClipboardList className="icon" />, 
    title: "Materials",
    description: (
      <ul>
        <li>FR4: A common PCB material used for less demanding applications.</li>
        <li>Aluminum PCBs: These are widely used for high-performance LEDs because they offer better heat dissipation than FR4.</li>
        <li>Copper PCBs: Known for superior thermal conductivity, these are used in high-power LEDs.</li>
      </ul>
    ),
  },
  {
    icon: <FaThList className="icon" />, 
    title: "Types of LED PCBs",
    description: (
      <ul>
        <li>Single-Sided LED PCBs: LEDs are mounted on one side of the PCB.</li>
        <li>Double-Sided LED PCBs: LEDs are mounted on both sides, offering more efficient use of space.</li>
        <li>Flexible LED PCBs: These are bendable, which makes them useful for curved or flexible lighting designs.</li>
        <li>Metal Core LED PCBs (MCPCBs): These are designed with a metal base (typically aluminum) to improve heat dissipation.</li>
      </ul>
    ),
  },
  {
    icon: <FaBolt className="icon" />, 
    title: "Applications",
    description: (
      <ul>
        <li>LED lighting (bulbs, strips, panels)</li>
        <li>Backlighting for displays</li>
        <li>Automotive lighting</li>
        <li>Signs and displays</li>
      </ul>
    ),
  },
];

function News() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFeature = (index) => {
    setActiveIndex(activeIndex === index ? null : index);

  };
  const sectionRef = useRef(null); 
  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll(".animated");

    gsap.fromTo(
      elements,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 85%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);
  return (
    <div className="news-wrapper-page">
      {/* <CustomNav /> */}
      <NewNav/>
      <div className="news-video-wrapper">
        <h2 data-aos="zoom-in-right">What’s New</h2>
        <section className="news-section">
          <Container>
            <Row>
              {/* Left Column - Video Background with Overlay Text */}
              <Col lg={8} className="video-container mb-4"data-aos="fade-zoom-in"
     data-aos-easing="ease-in-back"
     data-aos-delay="300"
     data-aos-offset="0">
                <div className="video-wrapper">
                  <video autoPlay loop muted className="background-video">
                    <source src={video} type="video/mp4" />
                  </video>
                  <div className="video-overlay">
                    <h3>QH Lighting</h3>
                    <p>
                      “At Qh Lighting, we are revolutionizing LED PCB manufacturing with cutting-edge technology, precision engineering, and an unwavering commitment to quality. Our advanced manufacturing processes ensure high-performance, reliable, and cost-effective solutions tailored to meet the evolving needs of the lighting and electronics industries. Whether for commercial, industrial, or custom applications, we deliver innovative LED PCB solutions that power a brighter, more efficient future.”
                    </p>
                  </div>
                </div>
              </Col>

              {/* Right Column - Product Display */}
              <Col lg={4} className="d-flex justify-content-center" data-aos="flip-left"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000">
                <Card className="product-card">
                  <Card.Img variant="top" src={news1} className="product-image" />
                  <Card.Body className="body-wraper">
                    <Card.Title className="card-heading">Smart LED Light</Card.Title>
                    <Card.Text>
                      <p>
                       These are copper needs to appeared in led pcb components section
                      </p>
                    </Card.Text>
                    {/* <button className="btn btn-primary">Buy Now</button> */}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
        <NewsCards />
      </div>
      {/* pcb section */}
      {/* <section className="pcbs-section">
        <Container>
          <h2 className="section-title">What Are LED PCBs?</h2>
          <Row className="align-items-center">
            <Col md={6} className="image-col"  data-aos="fade-right">
              <img src={pcb} alt="PCB Illustration" className="pcb-image" />
            </Col>
            <Col md={6} className="text-col"  data-aos="fade-left">
              <p className="intro-text">
                are specialized circuit boards designed to support and connect LED (Light Emitting Diode) components. These PCBs are an integral part of LED lighting systems, as they provide both the electrical connections and thermal management necessary to ensure the LEDs function properly and efficiently.
              </p>
              <div className="features">
                {features.map((feature, index) => (
                  <Card
                    className={`feature-card ${activeIndex === index ? "active" : ""}`}
                    key={index}
                    onClick={() => toggleFeature(index)}
                    data-aos="zoom-in"
                  >
                    <Card.Body className="feature-body">
                      <div className="feature-icon">{feature.icon}</div>
                      <span>{feature.title}</span>
                    </Card.Body>
                    {activeIndex === index && <p className="feature-description">{feature.description}</p>}
                  </Card>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
       <section className="pcbs-section" ref={sectionRef}>
      <Container>
        <h2 className="section-title animated">What Are LED PCBs?</h2>
        <Row className="align-items-center">
          <Col md={6} className="image-col animated">
            <img src={pcb} alt="PCB Illustration" className="pcb-image" />
          </Col>
          <Col md={6} className="text-col animated">
            <p className="intro-text">
              are specialized circuit boards designed to support and connect LED (Light Emitting Diode) components. These PCBs are an integral part of LED lighting systems, as they provide both the electrical connections and thermal management necessary to ensure the LEDs function properly and efficiently.
            </p>
            <div className="features">
              {features.map((feature, index) => (
                <Card
                  className={`feature-card animated ${activeIndex === index ? "active" : ""}`}
                  key={index}
                  onClick={() => toggleFeature(index)}
                >
                  <Card.Body className="feature-body">
                    <div className="feature-icon">{feature.icon}</div>
                    <span>{feature.title}</span>
                  </Card.Body>
                  {activeIndex === index && <p className="feature-description">{feature.description}</p>}
                </Card>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>

      {/* omponents */}
      <LEDPCB />
      <Footer />
    </div>
  );
}

export default News;
